
// (function($) {
//   console.log('FBT System Loading...');
  
//   let fbtInitialized = false;
//   let initializationAttempts = 0;
//   const maxAttempts = 15; // 15 attempts (7.5 seconds total)

//   // MAIN INITIALIZATION FUNCTION
//   function initFBT() {
//     initializationAttempts++;
    
//     console.log(`FBT: Initialization attempt ${initializationAttempts}/${maxAttempts}`);
    
//     // Check if the complementary products container exists
//     const $container = $('.complementary-products__container');
    
//     if (!$container.length) {
//       console.log('FBT: Container not found yet');
      
//       if (initializationAttempts < maxAttempts) {
//         setTimeout(initFBT, 500); // Try again after 500ms
//       } else {
//         console.log('FBT: Max attempts reached, giving up');
//       }
//       return;
//     }
    
//     // Now check for the actual elements inside the container
//     const $checkboxes = $container.find('.fbt-item-checkbox');
//     const $totalPriceEl = $('#fbt-total-price');
//     const $addButton = $('#fbt-add-all');
    
//     console.log('FBT Elements found:', {
//       container: $container.length,
//       checkboxes: $checkboxes.length,
//       totalEl: $totalPriceEl.length,
//       button: $addButton.length
//     });
    
//     if ($checkboxes.length === 0 || !$addButton.length) {
//       console.log('FBT: Required elements not ready yet');
      
//       if (initializationAttempts < maxAttempts) {
//         setTimeout(initFBT, 500);
//       }
//       return;
//     }
    
//     if (fbtInitialized) {
//       console.log('FBT: Already initialized, skipping');
//       return;
//     }
    
//     console.log('FBT: Successfully found all elements! Starting initialization...');
//     fbtInitialized = true;
    
//     // Debug: Show what's actually in the container
//     console.log('FBT: Container HTML snippet:', $container.html().substring(0, 300) + '...');
    
//     // SIMPLE AND RELIABLE VERSION
//     // -----------------------------------------
//     function updateTotal() {
//       let total = 0;
      
//       $checkboxes.each(function() {
//         if ($(this).is(':checked')) {
//           // Direct access to hidden price input
//           const $item = $(this).closest('.fbt-product-item');
//           const priceInput = $item.find('.fbt-product-price');
//           const price = parseFloat(priceInput.val()) || 0;
//           total += price;
//         }
//       });
      
//       if ($totalPriceEl.length) {
//         $totalPriceEl.text('₹' + total.toFixed(2));
//       }
      
//       console.log('FBT: Total updated to ₹' + total.toFixed(2));
//     }
    
//     // Attach event listeners
//     $container.on('change', '.fbt-item-checkbox', updateTotal);
    
//     // Initial calculation
//     updateTotal();
    
//     // Add to Cart functionality
//     $addButton.off('click').on('click', function(e) {
//       e.preventDefault();
//       console.log('FBT: Add to Cart clicked');
      
//       const $button = $(this);
//       const originalText = $button.text();
      
//       $button.text('Adding...').prop('disabled', true);
      
//       const itemsToAdd = [];
      
//       $checkboxes.each(function() {
//         if ($(this).is(':checked')) {
//           const $item = $(this).closest('.fbt-product-item');
//           const variantId = $item.find('.fbt-variant-id').val();
          
//           if (variantId) {
//             itemsToAdd.push({
//               id: variantId,
//               quantity: 1
//             });
//             console.log('FBT: Adding variant ID:', variantId);
//           }
//         }
//       });
      
//       if (itemsToAdd.length === 0) {
//         alert('Please select at least one product!');
//         $button.text(originalText).prop('disabled', false);
//         return;
//       }
      
//       console.log('FBT: Items to add:', itemsToAdd);
      
//       // Shopify Cart API Call
//       $.ajax({
//         url: '/cart/add.js',
//         method: 'POST',
//         dataType: 'json',
//         contentType: 'application/json',
//         data: JSON.stringify({ items: itemsToAdd })
//       })
//       .done(function(response) {
//         console.log('FBT: Success!', response);
//         $button.text('Added!');
        
//         // Update cart count if theme supports it
//         if (typeof theme !== 'undefined' && theme.cart) {
//           theme.cart.getCart();
//         }
        
//         // Redirect to cart page after delay
//         setTimeout(function() {
//           window.location.href = '/cart';
//         }, 1500);
//       })
//       .fail(function(jqXHR, textStatus, errorThrown) {
//         console.error('FBT: Error adding to cart:', {
//           status: jqXHR.status,
//           statusText: textStatus,
//           error: errorThrown,
//           response: jqXHR.responseText
//         });
        
//         $button.text('Error! Try Again');
//         setTimeout(function() {
//           $button.text(originalText).prop('disabled', false);
//         }, 3000);
//       });
//     });
    
//     console.log('FBT: System fully initialized and ready!');
    
//     // Debug current state
//     console.log('FBT: Current checkboxes state:');
//     $checkboxes.each(function(i) {
//       console.log(`  Checkbox ${i + 1}:`, {
//         checked: $(this).is(':checked'),
//         variantId: $(this).closest('.fbt-product-item').find('.fbt-variant-id').val(),
//         price: $(this).closest('.fbt-product-item').find('.fbt-product-price').val()
//       });
//     });
//   }
  
//   // MULTIPLE INITIALIZATION STRATEGIES
//   // -----------------------------------------
  
//   // 1. Start immediately when document is ready
//   $(document).ready(function() {
//     console.log('FBT: Document ready, starting initialization process');
    
//     // First attempt immediately
//     initFBT();
    
//     // Additional attempts at different intervals
//     setTimeout(initFBT, 1000);
//     setTimeout(initFBT, 2000);
//     setTimeout(initFBT, 4000);
//     setTimeout(initFBT, 7000);
//   });
  
//   // 2. Listen for Shopify section load events
//   $(document).on('shopify:section:load', function(event) {
//     console.log('FBT: Shopify section loaded event');
    
//     // Check if this is our complementary products section
//     const $target = $(event.target);
//     if ($target.is('.complementary-products') || 
//         $target.find('.complementary-products').length ||
//         $target.is('.complementary-products__container') ||
//         $target.find('.complementary-products__container').length) {
      
//       console.log('FBT: Complementary products section detected, re-initializing');
//       fbtInitialized = false;
//       initializationAttempts = 0;
      
//       // Wait a bit for the content to fully render
//       setTimeout(initFBT, 300);
//     }
//   });
  
//   // 3. Listen for any DOM changes (MutationObserver as fallback)
//   if (typeof MutationObserver !== 'undefined') {
//     const observer = new MutationObserver(function(mutations) {
//       for (const mutation of mutations) {
//         if (mutation.addedNodes.length > 0) {
//           // Check if complementary products were added
//           for (const node of mutation.addedNodes) {
//             if (node.nodeType === Node.ELEMENT_NODE) {
//               const $node = $(node);
//               if ($node.is('.complementary-products, .complementary-products__container') ||
//                   $node.find('.complementary-products, .complementary-products__container').length) {
                
//                 console.log('FBT: DOM mutation detected - complementary products added');
//                 if (!fbtInitialized) {
//                   setTimeout(initFBT, 500);
//                 }
//                 break;
//               }
//             }
//           }
//         }
//       }
//     });
    
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
  
// })(jQuery);

// open cart dawer code
// (function($) {
//   console.log('FBT System Loading...');
  
//   let fbtInitialized = false;
//   let initializationAttempts = 0;
//   const maxAttempts = 15; // 15 attempts (7.5 seconds total)

//   // MAIN INITIALIZATION FUNCTION
//   function initFBT() {
//     initializationAttempts++;
    
//     console.log(`FBT: Initialization attempt ${initializationAttempts}/${maxAttempts}`);
    
//     // Check if the complementary products container exists
//     const $container = $('.complementary-products__container');
    
//     if (!$container.length) {
//       console.log('FBT: Container not found yet');
      
//       if (initializationAttempts < maxAttempts) {
//         setTimeout(initFBT, 500); // Try again after 500ms
//       } else {
//         console.log('FBT: Max attempts reached, giving up');
//       }
//       return;
//     }
    
//     // Now check for the actual elements inside the container
//     const $checkboxes = $container.find('.fbt-item-checkbox');
//     const $totalPriceEl = $('#fbt-total-price');
//     const $addButton = $('#fbt-add-all');
    
//     console.log('FBT Elements found:', {
//       container: $container.length,
//       checkboxes: $checkboxes.length,
//       totalEl: $totalPriceEl.length,
//       button: $addButton.length
//     });
    
//     if ($checkboxes.length === 0 || !$addButton.length) {
//       console.log('FBT: Required elements not ready yet');
      
//       if (initializationAttempts < maxAttempts) {
//         setTimeout(initFBT, 500);
//       }
//       return;
//     }
    
//     if (fbtInitialized) {
//       console.log('FBT: Already initialized, skipping');
//       return;
//     }
    
//     console.log('FBT: Successfully found all elements! Starting initialization...');
//     fbtInitialized = true;
    
//     // Debug: Show what's actually in the container
//     console.log('FBT: Container HTML snippet:', $container.html().substring(0, 300) + '...');
    
//     // SIMPLE AND RELIABLE VERSION
//     // -----------------------------------------
//     function updateTotal() {
//       let total = 0;
      
//       $checkboxes.each(function() {
//         if ($(this).is(':checked')) {
//           // Direct access to hidden price input
//           const $item = $(this).closest('.fbt-product-item');
//           const priceInput = $item.find('.fbt-product-price');
//           const price = parseFloat(priceInput.val()) || 0;
//           total += price;
//         }
//       });
      
//       if ($totalPriceEl.length) {
//         $totalPriceEl.text('₹' + total.toFixed(2));
//       }
      
//       console.log('FBT: Total updated to ₹' + total.toFixed(2));
//     }
    
//     // Attach event listeners
//     $container.on('change', '.fbt-item-checkbox', updateTotal);
    
//     // Initial calculation
//     updateTotal();
    
//     // Add to Cart functionality - OPEN CART DRAWER
//     $addButton.off('click').on('click', function(e) {
//       e.preventDefault();
//       console.log('FBT: Add to Cart clicked');
      
//       const $button = $(this);
//       const originalText = $button.text();
      
//       $button.text('Adding...').prop('disabled', true);
      
//       const itemsToAdd = [];
      
//       $checkboxes.each(function() {
//         if ($(this).is(':checked')) {
//           const $item = $(this).closest('.fbt-product-item');
//           const variantId = $item.find('.fbt-variant-id').val();
          
//           if (variantId) {
//             itemsToAdd.push({
//               id: variantId,
//               quantity: 1
//             });
//             console.log('FBT: Adding variant ID:', variantId);
//           }
//         }
//       });
      
//       if (itemsToAdd.length === 0) {
//         alert('Please select at least one product!');
//         $button.text(originalText).prop('disabled', false);
//         return;
//       }
      
//       console.log('FBT: Items to add:', itemsToAdd);
      
//       // Shopify Cart API Call
//       $.ajax({
//         url: '/cart/add.js',
//         method: 'POST',
//         dataType: 'json',
//         contentType: 'application/json',
//         data: JSON.stringify({ items: itemsToAdd })
//       })
//       .done(function(response) {
//         console.log('FBT: Success!', response);
//         $button.text('Added!');
        
//         // Update cart count
//         updateCartCount();
        
//         // Open cart drawer instead of redirecting
//         openCartDrawer();
        
//         // Reset button after delay
//         setTimeout(function() {
//           $button.text(originalText).prop('disabled', false);
//         }, 2000);
//       })
//       .fail(function(jqXHR, textStatus, errorThrown) {
//         console.error('FBT: Error adding to cart:', {
//           status: jqXHR.status,
//           statusText: textStatus,
//           error: errorThrown,
//           response: jqXHR.responseText
//         });
        
//         $button.text('Error! Try Again');
//         setTimeout(function() {
//           $button.text(originalText).prop('disabled', false);
//         }, 3000);
//       });
//     });
    
//     console.log('FBT: System fully initialized and ready!');
    
//     // Debug current state
//     console.log('FBT: Current checkboxes state:');
//     $checkboxes.each(function(i) {
//       console.log(`  Checkbox ${i + 1}:`, {
//         checked: $(this).is(':checked'),
//         variantId: $(this).closest('.fbt-product-item').find('.fbt-variant-id').val(),
//         price: $(this).closest('.fbt-product-item').find('.fbt-product-price').val()
//       });
//     });
//   }
  
//   // Function to update cart count in header
//   function updateCartCount() {
//     // Try different methods to update cart count
//     console.log('FBT: Updating cart count...');
    
//     // Method 1: Shopify theme standard way
//     if (typeof theme !== 'undefined') {
//       if (theme.cart) {
//         theme.cart.getCart();
//         console.log('FBT: Updated cart via theme.cart');
//       }
//       if (theme.cartDrawer) {
//         theme.cartDrawer.getSectionsToRender();
//         console.log('FBT: Updated cart drawer sections');
//       }
//     }
    
//     // Method 2: Use Shopify's native cart API
//     $.getJSON('/cart.js', function(cart) {
//       // Update cart count badge if it exists
//       const $cartCount = $('.cart-count-bubble, .cart-count, .header__icon--cart .count');
//       if ($cartCount.length) {
//         $cartCount.text(cart.item_count);
//         $cartCount.toggle(cart.item_count > 0);
//       }
//       console.log('FBT: Cart count updated to:', cart.item_count);
//     });
    
//     // Method 3: Dispatch custom event for other scripts to listen to
//     $(document).trigger('cart:updated');
//   }
  
//   // Function to open cart drawer
//   function openCartDrawer() {
//     console.log('FBT: Opening cart drawer...');
    
//     // Method 1: Standard Shopify Dawn theme
//     const $cartDrawerToggle = $('cart-drawer');
//     if ($cartDrawerToggle.length) {
//       $cartDrawerToggle[0].open();
//       console.log('FBT: Cart drawer opened via cart-drawer element');
//       return;
//     }
    
//     // Method 2: Shopify Sections theme
//     const $cartIcon = $('.header__icon--cart, .cart-icon, [href="/cart"]');
//     if ($cartIcon.length) {
//       $cartIcon.trigger('click');
//       console.log('FBT: Cart drawer opened via cart icon click');
//       return;
//     }
    
//     // Method 3: Custom cart drawer with class
//     const $cartToggle = $('[data-action="toggle-cart"], [aria-controls="CartDrawer"]');
//     if ($cartToggle.length) {
//       $cartToggle.trigger('click');
//       console.log('FBT: Cart drawer opened via data attribute');
//       return;
//     }
    
//     // Method 4: Look for drawer element and show it
//     const $cartDrawer = $('#CartDrawer, .cart-drawer, [id*="cart-drawer"], [id*="CartDrawer"]');
//     if ($cartDrawer.length) {
//       $cartDrawer.addClass('active').attr('aria-hidden', 'false');
//       $('body').addClass('overflow-hidden');
//       console.log('FBT: Cart drawer opened via class manipulation');
//       return;
//     }
    
//     // Method 5: If cart drawer not found, show success message
//     console.log('FBT: Cart drawer not found, showing success message');
//     showSuccessMessage('Products added to cart!');
//   }
  
//   // Fallback success message function
//   function showSuccessMessage(message) {
//     // Create or show existing success message
//     let $message = $('.fbt-success-message');
    
//     if (!$message.length) {
//       $message = $(`
//         <div class="fbt-success-message" style="
//           position: fixed;
//           top: 20px;
//           right: 20px;
//           background: #4CAF50;
//           color: white;
//           padding: 15px 20px;
//           border-radius: 4px;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.15);
//           z-index: 10000;
//           display: none;
//           animation: fadeIn 0.3s ease;
//         ">
//           <span style="margin-right: 10px;">✓</span>
//           ${message}
//         </div>
//       `).appendTo('body');
//     } else {
//       $message.text(`✓ ${message}`);
//     }
    
//     $message.fadeIn();
    
//     setTimeout(function() {
//       $message.fadeOut();
//     }, 3000);
//   }
  
//   // MULTIPLE INITIALIZATION STRATEGIES
//   // -----------------------------------------
  
//   // 1. Start immediately when document is ready
//   $(document).ready(function() {
//     console.log('FBT: Document ready, starting initialization process');
    
//     // First attempt immediately
//     initFBT();
    
//     // Additional attempts at different intervals
//     setTimeout(initFBT, 1000);
//     setTimeout(initFBT, 2000);
//     setTimeout(initFBT, 4000);
//     setTimeout(initFBT, 7000);
//   });
  
//   // 2. Listen for Shopify section load events
//   $(document).on('shopify:section:load', function(event) {
//     console.log('FBT: Shopify section loaded event');
    
//     // Check if this is our complementary products section
//     const $target = $(event.target);
//     if ($target.is('.complementary-products') || 
//         $target.find('.complementary-products').length ||
//         $target.is('.complementary-products__container') ||
//         $target.find('.complementary-products__container').length) {
      
//       console.log('FBT: Complementary products section detected, re-initializing');
//       fbtInitialized = false;
//       initializationAttempts = 0;
      
//       // Wait a bit for the content to fully render
//       setTimeout(initFBT, 300);
//     }
//   });
  
//   // 3. Listen for any DOM changes (MutationObserver as fallback)
//   if (typeof MutationObserver !== 'undefined') {
//     const observer = new MutationObserver(function(mutations) {
//       for (const mutation of mutations) {
//         if (mutation.addedNodes.length > 0) {
//           // Check if complementary products were added
//           for (const node of mutation.addedNodes) {
//             if (node.nodeType === Node.ELEMENT_NODE) {
//               const $node = $(node);
//               if ($node.is('.complementary-products, .complementary-products__container') ||
//                   $node.find('.complementary-products, .complementary-products__container').length) {
                
//                 console.log('FBT: DOM mutation detected - complementary products added');
//                 if (!fbtInitialized) {
//                   setTimeout(initFBT, 500);
//                 }
//                 break;
//               }
//             }
//           }
//         }
//       }
//     });
    
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
  
// })(jQuery);

(function($) {
  console.log('FBT System Loading...');
  
  let fbtInitialized = false;
  let initializationAttempts = 0;
  const maxAttempts = 15; // 15 attempts (7.5 seconds total)

  // MAIN INITIALIZATION FUNCTION
  function initFBT() {
    initializationAttempts++;
    
    console.log(`FBT: Initialization attempt ${initializationAttempts}/${maxAttempts}`);
    
    // Check if the complementary products container exists
    const $container = $('.complementary-products__container');
    
    if (!$container.length) {
      console.log('FBT: Container not found yet');
      
      if (initializationAttempts < maxAttempts) {
        setTimeout(initFBT, 500); // Try again after 500ms
      } else {
        console.log('FBT: Max attempts reached, giving up');
      }
      return;
    }
    
    // Now check for the actual elements inside the container
    const $checkboxes = $container.find('.fbt-item-checkbox');
    const $totalPriceEl = $('#fbt-total-price');
    const $addButton = $('#fbt-add-all');
    
    console.log('FBT Elements found:', {
      container: $container.length,
      checkboxes: $checkboxes.length,
      totalEl: $totalPriceEl.length,
      button: $addButton.length
    });
    
    if ($checkboxes.length === 0 || !$addButton.length) {
      console.log('FBT: Required elements not ready yet');
      
      if (initializationAttempts < maxAttempts) {
        setTimeout(initFBT, 500);
      }
      return;
    }
    
    if (fbtInitialized) {
      console.log('FBT: Already initialized, skipping');
      return;
    }
    
    console.log('FBT: Successfully found all elements! Starting initialization...');
    fbtInitialized = true;
    
    // Debug: Show what's actually in the container
    console.log('FBT: Container HTML snippet:', $container.html().substring(0, 300) + '...');
    
    // SIMPLE AND RELIABLE VERSION
    // -----------------------------------------
    function updateTotal() {
      let total = 0;
      
      $checkboxes.each(function() {
        if ($(this).is(':checked')) {
          // Direct access to hidden price input
          const $item = $(this).closest('.fbt-product-item');
          const priceInput = $item.find('.fbt-product-price');
          const price = parseFloat(priceInput.val()) || 0;
          total += price;
        }
      });
      
      if ($totalPriceEl.length) {
        $totalPriceEl.text('₹' + total.toFixed(2));
      }
      
      console.log('FBT: Total updated to ₹' + total.toFixed(2));
    }
    
    // Attach event listeners
    $container.on('change', '.fbt-item-checkbox', updateTotal);
    
    // Initial calculation
    updateTotal();
    
    // Add to Cart functionality - OPEN CART DRAWER
    $addButton.off('click').on('click', function(e) {
      e.preventDefault();
      console.log('FBT: Add to Cart clicked');
      
      const $button = $(this);
      const originalText = $button.text();
      
      $button.text('Adding...').prop('disabled', true);
      
      const itemsToAdd = [];
      
      $checkboxes.each(function() {
        if ($(this).is(':checked')) {
          const $item = $(this).closest('.fbt-product-item');
          const variantId = $item.find('.fbt-variant-id').val();
          
          if (variantId) {
            itemsToAdd.push({
              id: variantId,
              quantity: 1
            });
            console.log('FBT: Adding variant ID:', variantId);
          }
        }
      });
      
      if (itemsToAdd.length === 0) {
        alert('Please select at least one product!');
        $button.text(originalText).prop('disabled', false);
        return;
      }
      
      console.log('FBT: Items to add:', itemsToAdd);
      
      // Shopify Cart API Call
      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: itemsToAdd })
      })
      .done(function(response) {
        console.log('FBT: Success!', response);
        $button.text('Added!');
        
        // Update cart drawer using your working code
        updateCartDrawerAndOpen();
        
        // Reset button after delay
        setTimeout(function() {
          $button.text(originalText).prop('disabled', false);
        }, 2000);
      })
      .fail(function(jqXHR, textStatus, errorThrown) {
        console.error('FBT: Error adding to cart:', {
          status: jqXHR.status,
          statusText: textStatus,
          error: errorThrown,
          response: jqXHR.responseText
        });
        
        $button.text('Error! Try Again');
        setTimeout(function() {
          $button.text(originalText).prop('disabled', false);
        }, 3000);
      });
    });
    
    console.log('FBT: System fully initialized and ready!');
    
    // Debug current state
    console.log('FBT: Current checkboxes state:');
    $checkboxes.each(function(i) {
      console.log(`  Checkbox ${i + 1}:`, {
        checked: $(this).is(':checked'),
        variantId: $(this).closest('.fbt-product-item').find('.fbt-variant-id').val(),
        price: $(this).closest('.fbt-product-item').find('.fbt-product-price').val()
      });
    });
  }
  
  // YOUR WORKING CART DRAWER UPDATE FUNCTION
  function updateCartDrawerAndOpen() {
    console.log('FBT: Updating cart drawer with your code...');
    
    let intervalId = setInterval(() => {
      const sec_id = 'cart-drawer';
      fetch(window.location.pathname + "?sections=cart-drawer")
        .then(res => res.json())
        .then(data => {                
          const html = new DOMParser().parseFromString(data[sec_id], 'text/html');                
          const cartDrawerElement = document.querySelector('cart-drawer');
          
          if (cartDrawerElement && html.querySelector('cart-drawer')) {
            cartDrawerElement.innerHTML = html.querySelector('cart-drawer').innerHTML;
            console.log('FBT: Cart drawer content updated');
            
            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                // Update cart count bubbles
                let bubbles = document.querySelectorAll('.cart-count-bubble');
                if (bubbles.length === 0) {
                  const bubbleDiv = document.createElement('div');
                  bubbleDiv.className = 'cart-count-bubble';
                  bubbleDiv.setAttribute('aria-live', 'polite');
                  bubbleDiv.setAttribute('aria-atomic', 'true');
                  bubbleDiv.setAttribute('id', 'cart-icon-bubble');
                  bubbleDiv.innerHTML = `
                    <span aria-hidden="true">${cart.item_count}</span>
                    <span class="visually-hidden">${cart.item_count} items</span>
                  `;

                  const cartIcons = document.querySelector('#cart-icon-bubble');
                  if (cartIcons) {
                    cartIcons.appendChild(bubbleDiv.cloneNode(true));
                  } else {
                    document.body.appendChild(bubbleDiv);
                  }
                } else {
                  bubbles.forEach(bubble => {
                    const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                    const hiddenSpan = bubble.querySelector('.visually-hidden');

                    if (visibleSpan) visibleSpan.textContent = cart.item_count;
                    if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;
                  });
                }
                
                console.log('FBT: Cart count updated to:', cart.item_count);
              });
              
            clearInterval(intervalId);
            
            // Open the cart drawer
            setTimeout(() => {
              if (cartDrawerElement) {
                cartDrawerElement.classList.remove('is-empty');
                if (cartDrawerElement.open) {
                  cartDrawerElement.open();
                  console.log('FBT: Cart drawer opened successfully');
                }
              }
            }, 300);
          }
        })
        .catch(err => {
          console.error('FBT: Failed to update cart drawer section:', err);
          clearInterval(intervalId);
          
          // Fallback: try to open drawer anyway
          setTimeout(openCartDrawerFallback, 500);
        });
    }, 1000);
  }
  
  // Fallback function to open cart drawer
  function openCartDrawerFallback() {
    console.log('FBT: Using fallback method to open cart drawer');
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      if (cartDrawer.open) {
        cartDrawer.open();
        console.log('FBT: Cart drawer opened via fallback');
        return;
      }
    }
    
    // Additional fallback methods
    const $cartDrawer = $('#CartDrawer, .cart-drawer, [id*="cart-drawer"], [id*="CartDrawer"]');
    if ($cartDrawer.length) {
      $cartDrawer.removeClass('is-empty').addClass('active is-open').attr('aria-hidden', 'false');
      $('body').addClass('overflow-hidden');
      console.log('FBT: Cart drawer opened via class manipulation (fallback)');
      return;
    }
    
    const $cartIcon = $('.header__icon--cart, .cart-icon, [href="/cart"]');
    if ($cartIcon.length) {
      $cartIcon.trigger('click');
      console.log('FBT: Cart drawer opened via cart icon click (fallback)');
      return;
    }
    
    console.log('FBT: Cart drawer not found, showing success message');
    showSuccessMessage('Products added to cart!');
  }
  
  // Success message function
  function showSuccessMessage(message) {
    let $message = $('.fbt-success-message');
    
    if (!$message.length) {
      $message = $(`
        <div class="fbt-success-message" style="
          position: fixed;
          top: 20px;
          right: 20px;
          background: #4CAF50;
          color: white;
          padding: 15px 20px;
          border-radius: 4px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          z-index: 10000;
          display: none;
          animation: fadeIn 0.3s ease;
        ">
          <span style="margin-right: 10px;">✓</span>
          ${message}
        </div>
      `).appendTo('body');
    } else {
      $message.text(`✓ ${message}`);
    }
    
    $message.fadeIn();
    
    setTimeout(function() {
      $message.fadeOut();
    }, 3000);
  }
  
  // MULTIPLE INITIALIZATION STRATEGIES
  // -----------------------------------------
  
  // 1. Start immediately when document is ready
  $(document).ready(function() {
    console.log('FBT: Document ready, starting initialization process');
    
    // First attempt immediately
    initFBT();
    
    // Additional attempts at different intervals
    setTimeout(initFBT, 1000);
    setTimeout(initFBT, 2000);
    setTimeout(initFBT, 4000);
    setTimeout(initFBT, 7000);
  });
  
  // 2. Listen for Shopify section load events
  $(document).on('shopify:section:load', function(event) {
    console.log('FBT: Shopify section loaded event');
    
    // Check if this is our complementary products section
    const $target = $(event.target);
    if ($target.is('.complementary-products') || 
        $target.find('.complementary-products').length ||
        $target.is('.complementary-products__container') ||
        $target.find('.complementary-products__container').length) {
      
      console.log('FBT: Complementary products section detected, re-initializing');
      fbtInitialized = false;
      initializationAttempts = 0;
      
      // Wait a bit for the content to fully render
      setTimeout(initFBT, 300);
    }
  });
  
  // 3. Listen for any DOM changes (MutationObserver as fallback)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          // Check if complementary products were added
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const $node = $(node);
              if ($node.is('.complementary-products, .complementary-products__container') ||
                  $node.find('.complementary-products, .complementary-products__container').length) {
                
                console.log('FBT: DOM mutation detected - complementary products added');
                if (!fbtInitialized) {
                  setTimeout(initFBT, 500);
                }
                break;
              }
            }
          }
        }
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
})(jQuery);